import ReactHtmlParser from "react-html-parser";

export default function FAQ({faqs}) {
  return (
    <div className='mt-4 stockFAQ'> 
        {faqs && faqs.map((item,key)=>(
            <div key={`faqs${key}`} className='mt-3 faqList'>
                <h3>{item.heading}</h3>
                <div>{ReactHtmlParser(item.description)}</div>
            </div>
        ))}               
    </div>
  )
}
